import { cn } from '@/lib/utils'
import { formatCompact } from '@/lib/format'

/** "9,820 / 10,000" with a thin bar; the bar turns amber near the limit and red over it. */
export function UsageBar({ value, limit, className }: { value: number; limit: number; className?: string }) {
  const ratio = limit > 0 ? value / limit : 0
  const tone = ratio > 1 ? 'bg-risk' : ratio >= 0.9 ? 'bg-warn' : 'bg-primary/70'
  return (
    <div className={cn('min-w-28', className)}>
      <div className="figures flex items-baseline justify-between gap-2 text-xs">
        <span className="font-medium text-foreground">{formatCompact(value)}</span>
        {limit > 0 && <span className="text-muted-foreground">of {formatCompact(limit)}</span>}
      </div>
      <div className="mt-1 h-1 overflow-hidden rounded-full bg-muted" role="meter" aria-valuenow={value} aria-valuemin={0} aria-valuemax={limit || undefined}>
        <div className={cn('h-full rounded-full', tone)} style={{ width: `${Math.min(ratio, 1) * 100}%` }} />
      </div>
    </div>
  )
}
